// Mock data for Animusz Studio redesign
// Portfolio items (Realizacje) - GIFs sourced from original animuszstudio.com

export const portfolio = [
  {
    id: 36,
    title: "Spot Taniec",
    category: "Spot reklamowy",
    year: "2023",
    gif: "https://animuszstudio.com/files/2305080129393gif-spot-taniec.gif",
    tags: ["2D", "Motion"],
  },
  {
    id: 35,
    title: "Butik",
    category: "Animacja",
    year: "2023",
    gif: "https://animuszstudio.com/files/2305071020413butik-01gif.gif",
    tags: ["2D", "Ilustracja"],
  },
  {
    id: 34,
    title: "Etiuda 2021",
    category: "Film krótkometrażowy",
    year: "2022",
    gif: "https://animuszstudio.com/files/22022406144032021.gif",
    tags: ["Tradycyjna", "2D"],
  },
  {
    id: 18,
    title: "Sunship Ballon",
    category: "Teledysk",
    year: "2020",
    gif: "https://animuszstudio.com/files/200403023608301_sunship-ballon.gif",
    tags: ["Wycinanka"],
  },
  {
    id: 15,
    title: "Spot Muzeum Włókiennictwa",
    category: "Spot",
    year: "2020",
    gif: "https://animuszstudio.com/files/200403023634305_spot-muzeum-wlokiennictwa-_mtt.gif",
    tags: ["Mieszana"],
  },
  {
    id: 17,
    title: "WFO Logo Animacja",
    category: "Ident",
    year: "2020",
    gif: "https://animuszstudio.com/files/200403023708312_wfo-logo-animacja.gif",
    tags: ["Motion"],
  },
  {
    id: 16,
    title: "Kulturanek - Czółówka",
    category: "Serial",
    year: "2020",
    gif: "https://animuszstudio.com/files/200403023743303_kulturanek-czolowka-2-seria.gif",
    tags: ["2D"],
  },
  {
    id: 9,
    title: "Bałodźki Samson",
    category: "Etiuda",
    year: "2020",
    gif: "https://animuszstudio.com/files/2305071020293200318054447302_-balodzki-samson_1.gif",
    tags: ["Lalkowa"],
  },
  {
    id: 14,
    title: "Bejbe",
    category: "Etiuda studencka",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403074200308_bejbe-etiuda-studencka.gif",
    tags: ["2D"],
  },
  {
    id: 19,
    title: "Viral Kapitan Żbik",
    category: "Viral",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403023912315_viral-kapitan-zbik-ksiazka.gif",
    tags: ["Wycinanka"],
  },
  {
    id: 13,
    title: "Last Tree Standing",
    category: "Animacja",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403023948311_last-tree-standing-animacja-2d.gif",
    tags: ["2D"],
  },
  {
    id: 12,
    title: "Viral Kuba Cichocki",
    category: "Teledysk",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403024006304_-viral-plyty-kuby-cichockiego.gif",
    tags: ["Mieszana"],
  },
  {
    id: 11,
    title: "FRU Festiwal Trailer",
    category: "Trailer",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403024028309_fru-frestiwal-trailer01.gif",
    tags: ["Motion"],
  },
  {
    id: 20,
    title: "Spot Owocni",
    category: "Spot",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403024055313_spot-owocnii.gif",
    tags: ["2D"],
  },
  {
    id: 28,
    title: "Salt",
    category: "Film",
    year: "2019",
    gif: "https://animuszstudio.com/files/200311034831317_salt.gif",
    tags: ["Tradycyjna"],
  },
  {
    id: 27,
    title: "Koalicja Miast Kultury",
    category: "Spot",
    year: "2019",
    gif: "https://animuszstudio.com/files/200318054528316_koalicja-miast-kultury.gif",
    tags: ["2D"],
  },
  {
    id: 10,
    title: "Czółówka Imiesłowy",
    category: "Ident",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403024956314_czolowka-imeslowy.gif",
    tags: ["Motion"],
  },
  {
    id: 21,
    title: "MS Wystawa Korespondencje",
    category: "Wystawa",
    year: "2019",
    gif: "https://animuszstudio.com/files/200403024939310_ms_wystawa-korespondencje01.gif",
    tags: ["Mieszana"],
  },
];

export const workshopsPreview = [
  { id: 30, gif: "https://animuszstudio.com/files/2004140201281gif-warsztay02.gif", title: "Warsztaty 01" },
  { id: 31, gif: "https://animuszstudio.com/files/2004140201551gify-warsztaty09.gif", title: "Warsztaty 02" },
  { id: 32, gif: "https://animuszstudio.com/files/2004140202121gify-warsztaty11.gif", title: "Warsztaty 03" },
  { id: 33, gif: "https://animuszstudio.com/files/2004140202301gify-warsztaty14.gif", title: "Warsztaty 04" },
];

export const clients = [
  "TVP Kultura",
  "Opus Film",
  "Muzeum Sztuki",
  "Muzeum Włókiennictwa",
  "WJT Team",
  "Breakthru Films",
  "Animoon",
  "Orange",
  "Carrefour",
];

export const techniques = [
  { id: "01", name: "Animacja 2D cyfrowa", desc: "Współczesne techniki cyfrowe z zachowaniem ręcznego charakteru rysunku." },
  { id: "02", name: "Animacja lalkowa", desc: "Klasyczna animacja poklatkowa z użyciem projektowanych lalek i scenografii." },
  { id: "03", name: "Wycinanka", desc: "Papierowe kompozycje ożywione klatka po klatce - poetycka tradycja polskiej szkoły animacji." },
  { id: "04", name: "Plastelina", desc: "Miejsce, gdzie materia spotyka wyobraźnię - ręcznie modelowane postacie." },
  { id: "05", name: "Technika mieszana", desc: "Swobodne łączenie technik dla wyjątkowego charakteru wizualnego." },
];

export const services = [
  "Krótkie formy animowane",
  "Teledyski",
  "Spoty reklamowe",
  "Elementy na strony www",
  "Wizualizacje",
  "Filmy edukacyjne",
  "Filmy instruktażowe",
];

export const workshopVideos = [
  { title: "Żyrafka i sad słoniowy", url: "https://www.youtube.com/embed/GZo6B7JP7NI", channel: "Muzeum Kinematografii" },
  { title: "Odyseja Filmowa / 27 lipca 2017", url: "https://www.youtube.com/embed/t3cvmMRP91I", channel: "Muzeum Kinematografii" },
];
